// extracted by mini-css-extract-plugin
export default {"switch_container":"ScrollMode_switch_container__lRQoY"};